module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.type === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('div', [_c('el-button', {
    on: {
      "click": _vm.addKnowledge
    }
  }, [_vm._v("新增知识点2")])], 1), _vm._v(" "), _c('knowledge-table', {
    attrs: {
      "tableData": _vm.knowledgeList
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("关联其它知识点,方式，拷贝本题guid，然后到知识点列表中查找到相应知识点，在其后点关联")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("本题guid ：" + _vm._s(_vm.tmguid))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-690efb46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledgeTableFatherDlg/src/main.vue
// module id = 647
// module chunks = 2